import { atom } from "recoil";

const navMenuStateAtom = atom({

    key:"navMenuState",
    default: false

});

export default navMenuStateAtom;